export default __webpack_public_path__ + "static/media/automovelAutoValorMobile.d92ac79f.png";